import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { PredicateInput } from '@/features/PredicateInput';
import type { KmEntityCardFormValues } from './useKmEntityCardForm';

type Props = {
  /** Доступно ли изменение условия (право на администрирование модели знаний) */
  canEdit: boolean;
};

/**
 * Условие применимости экземпляра: то же поле, что и в остальных интерфейсах знаний.
 * Условие уходит текстом — привязанное переписывается, пустое поле снимает условие.
 *
 * Высота поля следует объёму условия, как у текстового значения атрибута: условие читается
 * целиком, не обрезаясь в одну строку.
 */
export const KmEntityPredicateField: FC<Props> = ({ canEdit }) => {
  const { t } = useTranslation('kmEntities');
  const { control } = useFormContext<KmEntityCardFormValues>();

  return (
    <div className="sm:col-span-2">
      <PredicateInput
        control={control}
        name="predicate"
        label={t('predicate')}
        disabled={!canEdit}
        type="textarea"
        rows={1}
      />
    </div>
  );
};
